module.exports = __webpack_public_path__ + "img/Anhänger_FüLa.1006eb89.svg";